import { Affix, CloseButton } from 'ui';

const CheckoutModalCloseButton = ({ onClick }: { onClick?: () => void }) => {
  return (
    <Affix position={{ top: 20, right: 20 }}>
      <CloseButton onClick={onClick} c="white" variant="transparent" />
    </Affix>
  );
};
export { CheckoutModalCloseButton };
